import { Component, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { CCCName } from '../services/settingService/setting.enum';
import { MultiselectVM } from 'src/app/viewModels/common/multiselect-vm';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-manage-sharedroles',
  templateUrl: './manage-sharedroles.component.html',
  styleUrls: ['./manage-sharedroles.component.scss']
})
export class ManageSharedRolesComponent implements OnInit {
 
  currentUser: any;
  organizationId: string;
  databaseId:string;
  responseHolder: any;
  OfficeIDList: any=[];
  myOfficeID: any;

  CorefolderID:number=0;
  ContactfolderID:number=0;
  CompanyfolderID:number=0;
  CoreName:string="";
  ContactName:string="";
  CompanyName:string="";

 
  CoredropdownSettings = {};
  CoredropdownList: any[] = [];
  CoreselectedItems:any= []=[];
  
  ContactdropdownSettings = {};
  ContactdropdownList: any[] = [];
  ContactselectedItems :any= []=[];
  
  CompanydropdownSettings = {};
  CompanydropdownList: any[] = [];
  CompanyselectedItems :any= []=[];

  rolesAsssign: any[] = []

  CoreDefaultSharingRoleSetting:any=[]=[];
  ContactDefaultSharingRoleSetting:any=[]=[];
  CompanyDefaultSharingRoleSetting:any=[]=[];

  SaveCoreButton:boolean=false;
  SaveContactButton:boolean=false;
  SaveCompanyButton:boolean=false;

    
  constructor(private loaderService: LoaderService, private toastr: ToastrService, private statusConst: StatusConstant, 
    private reusableClass: ReusableClasses, private dialog: MatDialog, private settingsService: SettingService, 
    private encryptionAlgo: EncryptionService,private mulstiselect: MultiselectVM,private formBuilder: FormBuilder) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngOnInit(): void {
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));

    var Core=[];
    var Contact=[];
    var Company=[];   
    
    Core = menuModulesList.filter(x => x.mainModuleName == CCCName.Core && x.isAssign == true);
    if(Core.length>0){
      this.CorefolderID = Core[0].folderID;
      this.CoreName = Core[0].orgModuleName;
    }
    Contact = menuModulesList.filter(x => x.mainModuleName == CCCName.Contact && x.isAssign == true);
    if(Contact.length>0){
      this.ContactfolderID = Contact[0].folderID;
      this.ContactName = Contact[0].orgModuleName; 
    }
    Company = menuModulesList.filter(x => x.mainModuleName == CCCName.Company && x.isAssign == true);
    if(Company.length>0){
      this.CompanyfolderID = Company[0].folderID;
      this.CompanyName = Company[0].orgModuleName; 
    }
    
    this.CoredropdownSettings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      enableCheckAll: true,
      allowSearchFilter: true
    };
    this.ContactdropdownSettings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      enableCheckAll: true,
      allowSearchFilter: true
    };
    this.CompanydropdownSettings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      enableCheckAll: true,
      allowSearchFilter: true
    };

    this.getDefaultSharingRoleSetting();
  }


  getRolesList() {
    var ReqModel={
      search : '',
      pageSize: 0,
      pageIndex: 0,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList
    }
    this.settingsService.getRoleList(ReqModel).subscribe(response=>{     
    if (response) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {       
        this.CoredropdownList = this.responseHolder.data.roleModel;
        this.ContactdropdownList = this.responseHolder.data.roleModel;
        this.CompanydropdownList = this.responseHolder.data.roleModel;
        this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));  
        if(this.rolesAsssign !=null){
          if(this.rolesAsssign?.length > 0){

           this.rolesAsssign = Object.values(
              this.rolesAsssign.reduce((a, c) => {
                a[c.roleID] = c;
                return a
              }, {}))

           var min=[];
           if(this.rolesAsssign.length==1){
            this.CoredropdownList=this.CoredropdownList.filter((m) => m.roleLevel >=this.rolesAsssign[0].roleLevel);
            this.ContactdropdownList=this.ContactdropdownList.filter((m) => m.roleLevel >=this.rolesAsssign[0].roleLevel);
            this.CompanydropdownList=this.CompanydropdownList.filter((m) => m.roleLevel >=this.rolesAsssign[0].roleLevel);
           }
           if(this.rolesAsssign.length>1){
            // min = this.rolesAsssign.reduce((a, b)=>Math.min(a.roleLevel, b.roleLevel));
            // this.CoredropdownList=this.CoredropdownList.filter((m) => m.roleLevel >=min);
            // this.ContactdropdownList=this.ContactdropdownList.filter((m) => m.roleLevel >=min);
            // this.CompanydropdownList=this.CompanydropdownList.filter((m) => m.roleLevel >=min);

           // min = this.rolesAsssign.reduce((a, b)=>Math.min(a.roleLevel, b.roleLevel));
            this.CoredropdownList=this.CoredropdownList;//.filter((m) => m.roleLevel >=min);
            this.ContactdropdownList=this.ContactdropdownList;//.filter((m) => m.roleLevel >=min);
            this.CompanydropdownList=this.CompanydropdownList;//.filter((m) => m.roleLevel >=min);
           }          
          
          }
        } 

        if(this.CoredropdownList.length>0){
          var tempCoreArrayToHoldPermission=[];
          this.CoredropdownList.forEach(perm => {
           let copyModel = Object.assign({}, this.mulstiselect);
            copyModel.item_id = perm.roleID;
            copyModel.item_text = perm.roleName;
            tempCoreArrayToHoldPermission.push(copyModel);
          });
          this.CoredropdownList = tempCoreArrayToHoldPermission;   
        }
        if(this.ContactdropdownList.length>0){
          var tempContactArrayToHoldPermission=[];
          this.ContactdropdownList.forEach(perm => {
           let copyModel = Object.assign({}, this.mulstiselect);
            copyModel.item_id = perm.roleID;
            copyModel.item_text = perm.roleName;
            tempContactArrayToHoldPermission.push(copyModel);
          });
          this.ContactdropdownList = tempContactArrayToHoldPermission;   
        }
        if(this.CompanydropdownList.length>0){
          var tempCompanyArrayToHoldPermission=[];
          this.CompanydropdownList.forEach(perm => {
           let copyModel = Object.assign({}, this.mulstiselect);
            copyModel.item_id = perm.roleID;
            copyModel.item_text = perm.roleName;
            tempCompanyArrayToHoldPermission.push(copyModel);
          });
          this.CompanydropdownList = tempCompanyArrayToHoldPermission;   
        }
        
        

        // Show Selected Role in Core Multiple Dropdown
        if(this.CoreDefaultSharingRoleSetting.length>0){
          var coremappedRoles=[];
          let tempcoreArray = [];
          coremappedRoles = this.CoreDefaultSharingRoleSetting[0].mappedRoles;
          coremappedRoles.forEach(e => {
            var coreselect= this.CoredropdownList.find(n=>n.item_text==e.roleName)
            if(coreselect!=null && coreselect!=undefined){
              let copyModel = Object.assign({}, this.mulstiselect);
              copyModel.item_id =coreselect.item_id;
              copyModel.item_text = coreselect.item_text;
              tempcoreArray.push(copyModel);
            }
           });
           this.CoreselectedItems = tempcoreArray;
        }

        // Show Selected Role in Contact Multiple Dropdown
        if(this.ContactDefaultSharingRoleSetting.length>0){
          var contactmappedRoles=[];
          let tempcontactArray = [];
          contactmappedRoles = this.ContactDefaultSharingRoleSetting[0].mappedRoles;
          contactmappedRoles.forEach(e => {
            var contactselect= this.ContactdropdownList.find(n=>n.item_text==e.roleName)
            if(contactselect!=null && contactselect!=undefined){
              let copyModel = Object.assign({}, this.mulstiselect);
              copyModel.item_id =contactselect.item_id;
              copyModel.item_text = contactselect.item_text;
              tempcontactArray.push(copyModel);
            }
           });
           this.ContactselectedItems = tempcontactArray;
        }


         // Show Selected Role in Company Multiple Dropdown
         if(this.CompanyDefaultSharingRoleSetting.length>0){
          var companymappedRoles=[];
          let tempcompanyArray = [];
          companymappedRoles = this.CompanyDefaultSharingRoleSetting[0].mappedRoles;
          companymappedRoles.forEach(e => {
            var companyselect= this.CompanydropdownList.find(n=>n.item_text==e.roleName)
            if(companyselect!=null && companyselect!=undefined){
              let copyModel = Object.assign({}, this.mulstiselect);
              copyModel.item_id =companyselect.item_id;
              copyModel.item_text = companyselect.item_text;
              tempcompanyArray.push(copyModel);
            }
           });
           this.CompanyselectedItems = tempcompanyArray;
        }

       }
      }
    });
  }

 

  getDefaultSharingRoleSetting() {
    this.SaveCoreButton=false;
    this.SaveContactButton=false;
    this.SaveCompanyButton=false;   

    var ReqModel={
      officeID: this.myOfficeID,
      userID: this.currentUser.UID, 
      organizationID: Number(this.organizationId),
      OfficeIDList:this.OfficeIDList
    }
    this.loaderService.show();
    this.settingsService.GetDefaultSharingRoleSetting(ReqModel).subscribe(response=>{     
    if (response != undefined) {
      this.responseHolder = response;
      this.loaderService.hide();
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        if(this.responseHolder.data!=null && this.responseHolder.data!=undefined){
          this.CoreDefaultSharingRoleSetting = this.responseHolder.data.filter(m=>m.folderName == CCCName.Core);
          this.ContactDefaultSharingRoleSetting = this.responseHolder.data.filter(m=>m.folderName == CCCName.Contact);
          this.CompanyDefaultSharingRoleSetting = this.responseHolder.data.filter(m=>m.folderName == CCCName.Company);
         
          this.getRolesList();   
        }else{
          this.getRolesList();
          this.loaderService.hide();
         }
       }else{
        this.getRolesList();
        this.loaderService.hide();
       }
      }else{
        this.getRolesList();
        this.loaderService.hide();
     }
    });
  }


  // Save / Update Core Role Details
  
  SaveCoreRole() {
    var defaultsharingRolesCore=[];
    var deleteAll:boolean=false;  
    if(this.CoreselectedItems.length>0){
      deleteAll=false;
      this.CoreselectedItems.forEach(e => {
        var ObjModel={
          roleID:e.item_id,
          folderID: this.CorefolderID,
          defaultsharingRolesMappingID: 0
         }
         defaultsharingRolesCore.push(ObjModel);       
       });  
    }else{
      deleteAll=true;
    }  
    
    this.loaderService.show();
    var ReqModel = {
      officeID:this.myOfficeID,
      defaultsharingRoles:defaultsharingRolesCore,
      userId: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      deleteAll:deleteAll,
      folderID:this.CorefolderID,
      OfficeIDList:this.OfficeIDList
    }
    this.settingsService.AddEditDefaultsharingRoles(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;       
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.CoreselectedItems=[];
          this.CoredropdownList=[];          
          this.CoreDefaultSharingRoleSetting=[];      
              
          this.getDefaultSharingRoleSetting();
          this.toastr.success('Roles shared successfully.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
        }else{
          this.CoreselectedItems=[];
          this.CoredropdownList=[];          
          this.CoreDefaultSharingRoleSetting=[];
          this.getDefaultSharingRoleSetting();
          this.loaderService.hide();
        }
      }else{
        this.CoreselectedItems=[];
        this.CoredropdownList=[];          
        this.CoreDefaultSharingRoleSetting=[];
        this.getDefaultSharingRoleSetting();
        this.loaderService.hide();
      }
    });
  }

   // Save / Update Contact Role Details  
   SaveContactRole() {   
    var defaultsharingRolesContact=[];
    var deleteAll:boolean=false;  
    if(this.ContactselectedItems.length>0){
      deleteAll=false;
      this.ContactselectedItems.forEach(e => {
        var ObjModel={
          roleID:e.item_id,
          folderID: this.ContactfolderID,
          defaultsharingRolesMappingID: 0
         }
         defaultsharingRolesContact.push(ObjModel);       
       });  
    }else{
      deleteAll=true;
    }  
    
    this.loaderService.show();
    var ReqModel = {
      officeID:this.myOfficeID,
      defaultsharingRoles:defaultsharingRolesContact,
      userId: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      deleteAll:deleteAll,
      folderID:this.ContactfolderID,
      OfficeIDList:this.OfficeIDList
    }
    this.settingsService.AddEditDefaultsharingRoles(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;       
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.ContactselectedItems=[];
          this.ContactdropdownList=[];          
          this.ContactDefaultSharingRoleSetting=[];      
         
          this.getDefaultSharingRoleSetting();
          this.toastr.success('Roles shared successfully.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
        }else{
          this.ContactselectedItems=[];
          this.ContactdropdownList=[];          
          this.ContactDefaultSharingRoleSetting=[];   
          this.getDefaultSharingRoleSetting();
          this.loaderService.hide();
        }
      }else{
        this.ContactselectedItems=[];
        this.ContactdropdownList=[];          
        this.ContactDefaultSharingRoleSetting=[];   
        this.getDefaultSharingRoleSetting();
        this.loaderService.hide();
      }
    });
   }  


   // Save / Update Company Role Details 
   SaveCompanyRole() {   
    var defaultsharingRolesCompany=[];
    var deleteAll:boolean=false;  
    if(this.CompanyselectedItems.length>0){
      deleteAll=false;
      this.CompanyselectedItems.forEach(e => {
        var ObjModel={
          roleID:e.item_id,
          folderID: this.CompanyfolderID,
          defaultsharingRolesMappingID: 0
         }
         defaultsharingRolesCompany.push(ObjModel);       
       });  
    }else{
      deleteAll=true;
    }  
    
    this.loaderService.show();
    var ReqModel = {
      officeID:this.myOfficeID,
      defaultsharingRoles:defaultsharingRolesCompany,
      userId: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      deleteAll:deleteAll,
      folderID:this.CompanyfolderID,
      OfficeIDList:this.OfficeIDList
    }
    this.settingsService.AddEditDefaultsharingRoles(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;       
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.CompanyselectedItems=[];
          this.CompanydropdownList=[];          
          this.CompanyDefaultSharingRoleSetting=[];
          this.getDefaultSharingRoleSetting();
          this.toastr.success('Roles shared successfully.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
        }else{
          this.CompanyselectedItems=[];
          this.CompanydropdownList=[];          
          this.CompanyDefaultSharingRoleSetting=[];
          this.getDefaultSharingRoleSetting();
          this.loaderService.hide();
        }
      }else{
        this.CompanyselectedItems=[];
        this.CompanydropdownList=[];          
        this.CompanyDefaultSharingRoleSetting=[];
        this.getDefaultSharingRoleSetting();
        this.loaderService.hide();
      }
    });
   } 

 

  //  Core Item Select / DeSelect / Select All / DeSelect All  

  CoreonItemSelect(item: any) {    
    this.SaveCoreButton=true;
  }

  CoreOnItemDeSelect(item: any) {
    this.SaveCoreButton=true;
  }

  CoreonSelectAll(items: any) {
    this.SaveCoreButton=true;
  }

  CoreonDeSelectAll(items: any) {
    this.SaveCoreButton=true;
  }

 
 //  Contact Item Select / DeSelect / Select All / DeSelect All

 ContactonItemSelect(item: any) {
  this.SaveContactButton=true;
 }

 ContactOnItemDeSelect(item: any) {
  this.SaveContactButton=true;
 }

 ContactonSelectAll(items: any) {
  this.SaveContactButton=true;
 }

 ContactonDeSelectAll(items: any) {
  this.SaveContactButton=true;
 }


  //  Company Item Select / DeSelect / Select All / DeSelect All

  CompanyonItemSelect(item: any) {
    this.SaveCompanyButton=true;
  }
 
  CompanyOnItemDeSelect(item: any) {
    this.SaveCompanyButton=true;
  }
 
  CompanyonSelectAll(items: any) {
    this.SaveCompanyButton=true;
  }
 
  CompanyonDeSelectAll(items: any) {
    this.SaveCompanyButton=true;
  }
 

}